export default "__VITE_ASSET__Bo7tYkDt__"